<template>
<div class="row">
  
  <div class="col-12 mb-4" v-if="(consulta && consulta.tipo_status && consulta.tipo_status.id == 66)">
      <ed-alert
        type="success"
        :description="'Essa consulta foi LIBERADA em '+toDate(consulta.updated_at)"
        title="Atenção"
      />

      <div class="col-12  mt-4 text-center">
        <ed-button
          icon="fa fa-print"
          type="success"
          title="Clique Aqui para Imprimir"
          value="Imprimir ASO"
          @click="imprimirASO"
        />
      </div>
  </div>

  <div class="col-12 mb-4" v-else-if="(consulta && consulta.tipo_status && (consulta.tipo_status.id == 57 || consulta.tipo_status.id == 58))">
      <ed-alert
        type="error"
        :description="'Essa consulta foi '+consulta.tipo_status.descricao+' em '+toDate(consulta.updated_at)+'. Nenhuma alteração pode ser efetuada.'"
        title="Atenção"
      />

      <div class="col-12 mt-4 text-center">
        <ed-button
          icon="fa fa-arrow-left"
          type="primary"
          value="Voltar"
          @click="toRoute({name:'credenciada.consulta'})"
        />
      </div>
  </div>
  
  
  <div class="col-12 mb-2" v-loading="loadingContent" v-else>
    <b-table-simple class="table-v2" hover small responsive :stacked="(this.device == 'xs')">
      <b-thead head-variant="">
        <b-tr>
          <b-th>EXAME</b-th>
          <b-th>DATA</b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-if="formData">
        <b-tr v-for="(consulta_exame,i) in formData.exames" v-bind:key="i">
          <b-td>
            {{consulta_exame.exame.nome}}
            <span 
              v-if="consulta_exame.id_con_dem != '0'"
              style="font-size:9pt;" 
              class="tp-exame-dem" 
              title="Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
            >
							<br>Exame <b>demonstrativo</b> na consulta <label style="color:red">{{consulta_exame.id_con_dem}}</label>
						</span>

            <span 
              v-else-if="consulta_exame.id_con_rea != '0'"
              style="font-size:9pt;" 
              class="tp-exame-dem" 
              title="Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
            >
							<br>Exame <b>reaproveitado</b> na consulta <label style="color:red">{{consulta_exame.id_con_rea}}</label>
						</span>

          </b-td>
          <b-td>
            <el-date-picker
              v-model="consulta_exame.data"
              type="date"
              placeholder="dd/mm/aaaa"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              :disabled="formOption.empty == 1 || consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0"
              :title="(consulta_exame.id_con_rea != 0 || consulta_exame.id_con_dem != 0 ? 'A data deste exame não pode ser alterado' : '')"
            />
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

     <div class="col-12 text-center mt-3 mb-2">
        <el-checkbox 
          v-model="formOption.empty"
          :checked="formOption.empty == 1"
          @change="getConsulta"
        >
          <span style="color:red">Imprimir ASO com a data dos exames em branco</span>
        </el-checkbox>
      </div>

      <div class="col-12 text-center">
        <ed-button
          icon="fa fa-print"
          type="success"
          title="Clique Aqui para Imprimir"
          value="Salvar Alterações e Imprimir ASO"
          @click="imprimirASO"
        />
      </div>

  </div>

</div>
</template>

<script>
import Rest from 'common/rest'
import EdAlert from 'common/alert'
import EdForm from 'common/form'
import EdButton from 'common/button'

export default {
    name: 'aso',
    components:{EdAlert,EdForm,EdButton},
    mixins:[Rest],
    props:{
      consulta:{
        type: Object,
        default: {}
      }
    },
    watch:{
      'consulta.id'(){
        this.getConsulta()
      },
      'consulta.tipo_status.id'(){
      },
    },
    data () {
      return{
        loadingContent:false,
        loadingSave:false,
        formData:null,
        formOption:{
          empty: 0,
        },
      }
    },

    created(){
    },
    mounted(){
      this.getConsulta();
    },

    methods: {

      imprimirASO(){
        
        this.loadingSave = true;
        this.tabSelected = 'tab-aso';

        this.post('consulta/externa/editar',this.formData).then((result) =>{

          result = result[0];
          this.loadingSave = false;

          if(result.status == 200){

            this.formOption.empty = (this.formOption.empty ? 1 : 0);
            
            this.open('consulta/aso/'+this.toMd5(this.formData.id_con),this.formOption);
          }
        });
      },

      getConsulta(){

        if(!this.consulta || !this.consulta.id)return;

        this.loadingContent = true;
        this.tabSelected = 'tab-aso';

        this.get("consulta/externa/"+this.consulta.id).then(result =>{

          result = result[0];
          this.loadingContent = false;

          if(result.status == 200){
            this.formData = result.data;
          }
        });
      },
    }
}
</script>


// WEBPACK FOOTER //
// aso.vue?6a7422b9